import * as React from 'react';
import { useState } from 'react';
import { PopEdit as DesignPopEdit } from '@whalecloud/fdx';
import { RemoteComponent } from '@components/RemoteComponent';

const PopEdit = ({ element, value, onChange, ...restProps }) => {
  const { settings = {} } = element.data;
  let { formItemSettings = {} } = element.data;
  const { defaultValue, modalProps: { render = '' }, allowClear } = formItemSettings;
  const { width } = settings;
  value = value || defaultValue
  const [curVal, setCurVal] = useState(value);

  const handleOk = (val: any) => {
    value = val
  }
  const handleChange = val => {
    onChange(val)
    if (allowClear) {
      setCurVal(val);
    }
  }
  const modalProps = {
    ...formItemSettings?.modalProps,
    onOk: handleOk,
  }
  const inputProps = {
    ...formItemSettings?.inputProps,
    allowClear,
  }
  formItemSettings = {
    ...formItemSettings,
    value: allowClear ? curVal : value,
    defaultValue,
    onChange: handleChange,
    modalProps: { ...modalProps },
    inputProps,
  }
  if (allowClear){
    formItemSettings.onClear = () => setCurVal('')
  }
  if (render) {
    // 通过远程组件渲染 Modal
    const ModalComponent = (props: any) => <RemoteComponent url={render} {...props} />

    const hanlderComponentRender = (handleValue: any) => {
      const { value, defaultValue, dataTextField, dataValueField } = formItemSettings;
      const ModalComponentProps = { value, defaultValue, dataTextField, dataValueField }
      return (
        <ModalComponent handleValue={handleValue} {...ModalComponentProps} />
      )
    }
    formItemSettings.modalProps.render = (handleValue) => hanlderComponentRender(handleValue)
  }

  return (
    <DesignPopEdit style={{ width: width.value }} {...formItemSettings} {...restProps} />
  );
};

export default PopEdit;
